function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { cookiesToTransform } from "./constants";
import { debug, removeQueryParameter as removeQueryParameterHistoryApi, ensureQueryParameter as setQueryParameterHistoryApi } from "../../utils";
/**
 * Reads cookie and transforms them into url - if found
 */
export var useCookieToUrl = function useCookieToUrl(parameters) {
  useEffect(function () {
    var _parameters$removeQue, _parameters$setQueryP;
    var removeQueryParameter = (_parameters$removeQue = parameters === null || parameters === void 0 ? void 0 : parameters.removeQueryParameter) !== null && _parameters$removeQue !== void 0 ? _parameters$removeQue : removeQueryParameterHistoryApi;
    var setQueryParameter = (_parameters$setQueryP = parameters === null || parameters === void 0 ? void 0 : parameters.setQueryParameter) !== null && _parameters$setQueryP !== void 0 ? _parameters$setQueryP : setQueryParameterHistoryApi;
    var foundPrev = false;
    var _iterator = _createForOfIteratorHelper(cookiesToTransform),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cookieInfo = _step.value;
        var cookieName = cookieInfo.cookie,
          queryParamName = cookieInfo.queryParam,
          stopIfFound = cookieInfo.stopIfFound,
          stopIfFoundPrev = cookieInfo.stopIfFoundPrev,
          removeIfNotFound = cookieInfo.removeIfNotFound;
        var cookieValue = Cookies.get(cookieName);
        var stop = stopIfFoundPrev && foundPrev;

        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- eslint rule conflict - there is no way how to correctly satisfy eslint
        if (!(cookieValue !== null && cookieValue !== void 0 && cookieValue.length)) {
          if (removeIfNotFound) {
            removeQueryParameter(queryParamName);
          }
          debug("Cookie value under the name of '".concat(cookieName, "' was not found!"));
          foundPrev = false;

          // stop if we should stop prematurely
          if (stop) {
            break;
          }
          continue;
        }

        // Ensure that query parameter is present and with correct value
        setQueryParameter(queryParamName, cookieValue);
        foundPrev = true;
        if (stopIfFound !== null && stopIfFound !== void 0 ? stopIfFound : stop) {
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, [parameters === null || parameters === void 0 ? void 0 : parameters.removeQueryParameter, parameters === null || parameters === void 0 ? void 0 : parameters.setQueryParameter]);
};